module.exports = __webpack_public_path__ + "static/media/Coffee with cel.dd327162.jpg";